import { createFileRoute } from "@tanstack/react-router";

import { useI18n, type MessageKey } from "~/lib/i18n";
import { ui } from "~/lib/ui";

export const Route = createFileRoute("/open-data")({
  component: OpenData,
});

// Served by the partner REST API's public open-data endpoints.
const downloads: { title: MessageKey; body: MessageKey; href: string; file: string }[] = [
  { title: "openDataGtfs", body: "openDataGtfsBody", href: "/api/v0/open-data/gtfs.zip", file: "gtfs.zip" },
  { title: "openDataRoutes", body: "openDataRoutesBody", href: "/api/v0/open-data/csv/routes", file: "routes.csv" },
  { title: "openDataStops", body: "openDataStopsBody", href: "/api/v0/open-data/csv/stops", file: "stops.csv" },
  { title: "openDataSchedules", body: "openDataSchedulesBody", href: "/api/v0/open-data/csv/schedules", file: "schedules.csv" },
  { title: "openDataFares", body: "openDataFaresBody", href: "/api/v0/open-data/csv/fares", file: "fares.csv" },
];

function OpenData() {
  const { t } = useI18n();

  return (
    <div className="mx-auto max-w-xl space-y-6">
      <div>
        <h1 className={ui.h1}>{t("openData")}</h1>
        <p className={ui.lead}>{t("openDataIntro")}</p>
      </div>
      <ul className="divide-y divide-slate-200 rounded-xl border border-slate-200 dark:divide-slate-800 dark:border-slate-800">
        {downloads.map((d) => (
          <li key={d.href} className="flex items-start justify-between gap-4 p-4">
            <div>
              <h2 className="font-semibold">{t(d.title)}</h2>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{t(d.body)}</p>
            </div>
            <a
              href={d.href}
              download={d.file}
              className={`shrink-0 ${ui.primary}`}
            >
              {t("openDataDownload")}
              <span className="sr-only"> {d.file}</span>
            </a>
          </li>
        ))}
      </ul>
      <p className="text-sm text-slate-600 dark:text-slate-400">{t("openDataLicence")}</p>
    </div>
  );
}
